import { useFormContext } from "@4uhub/lib4uhub";
import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { memo } from "react";
import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TMessageForm } from "../messagesSchema";

const translationPath = "page.4uMarCom.automationRules.marcom_message.";

export const TicketFlowPatternMessagesMarcom = memo(() => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<TMessageForm>();

  const { field } = useController({ control, name: "finishedFromStart" });

  const radios = [
    { label: t(translationPath + "finished_from_start"), value: false },
    { label: t(translationPath + "opened_with_flow_direction"), value: true },
  ];

  const handleChange = (opened: boolean) => {
    field.onChange(opened);

    if (!opened) {
      setValue("ticketChannel", null);
      setValue("ticketChannelStep", null);
      setValue("ticketAutomationReceivedRule", null);
      setValue("isMoveHumanAttendant", false);
      setValue("moveTicketWhenNotIdentified", false);
    }
  };

  return (
    <Grid item sm={12}>
      <RadioGroup row>
        {radios.map((radio) => (
          <FormControlLabel
            key={radio.label}
            value={radio.value}
            control={
              <Radio
                size="small"
                checked={field.value === radio.value}
                onChange={() => handleChange(radio.value)}
              />
            }
            label={radio.label}
            ref={field.ref}
          />
        ))}
      </RadioGroup>
    </Grid>
  );
});
